import { AcuerdoComercial } from '@/models/AcuerdoComercial';

/**
 * Metodo para destructurar los descuentos destinados a las UFS.
 * 
 * @param acuerdo_comercial 
 * @returns Arreglo con tres componentes:
 * Primer componente son los descuentos temporales: arrego de numbers
 * Segundo componente es el descuento permanente de una UF: number
 * Tercer componente es el descuento permanente de una cochera: number
 */
export function helperDestructurarDescuentosUfs(acuerdo_comercial: AcuerdoComercial){

  // Reinicio las variables utilizadas
  let descuentos_temporales= [];
  let descuento_permanente_uf= null;
  let descuento_permanente_cocheras= null;

  // Logica para descuentos permanentes
  if (acuerdo_comercial.descuentos_ufs.tipos){

    // Si estan seteados entonces hay descuento permanente
    descuento_permanente_uf= acuerdo_comercial.descuentos_ufs.tipos.general ?? null;
    descuento_permanente_cocheras = acuerdo_comercial.descuentos_ufs.tipos.cochera ?? null;
  }

  // Descuentos temporales
  if (acuerdo_comercial.descuentos_ufs.periodos){
    descuentos_temporales = destructurarDescuentosTemporales(acuerdo_comercial.descuentos_ufs.periodos);
  }

  return [descuentos_temporales, descuento_permanente_uf, descuento_permanente_cocheras];
}

/**
 * Metodo para calcular los descuentos temporales en formato JSON con atributos "meses" y "descuento"
 * Algoritmo: Contar consecutivos.
 * 
 * @param periodos Array de Numbers
 * @returns Array de numbers
 */
function destructurarDescuentosTemporales(periodos: number[]){
  let descuentos_temporales = [];

  // Logica: seria contar hasta que sean distintos e insertan en ese punto
  let contador = 1;
  for (let i = 0; i < periodos.length-1; i++) {
    if (periodos[i] === periodos[i+1]){
      contador++;
    }
    else{
      descuentos_temporales.push({'meses': contador, 'descuento': periodos[i]});
      contador = 1;
    }
  }

  // Caso borde del ultimo elemento o por si son todos iguales
  if (contador >= 1){
    descuentos_temporales.push({'meses': contador, 'descuento': periodos[periodos.length-1]});
  }

  return descuentos_temporales;
}


/**
 * Metodo helper para eliminar el mail de ventas y dejar solo el nombre del usuario
 * 
 * @param mail del usuario de ventas
 * @returns mail sanitizado, solo con el nombre o null en caso que el mail no este definido
 */
export function trimUsuarioSales(mail?: string){
  if (mail){
    let separacion = [];
    separacion = mail.split('@');

    if (separacion[0]){
      let separacion2 = separacion[0].replace('.ventas', '');
      return separacion2;
    }
    return mail; // fallback en caso que no tenga @
  }

  return null;
}

/**
 * Filtro para formatear contenido a mostrar en tablas. En caso de ser null, retorna un guión medio
 * @param texto
 */
export function GuionSiEsNulo(texto) {
  return !texto ? '-' : texto;
}


